import React from 'react';
import Furniture from 'components/Tvendo/BusinessPartner/DataMaster/Furniture/List.js';

export default function () {
  return <Furniture />;
}
